export default {"src":"/_next/static/media/phone-call-01.f683536f.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};